import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import RoutesContainer from "./components/RoutesContainer";
import { UserProvider } from "./UserContext";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import NavBar from "./components/Navigation";

const authComponents = {
  Header() {
    return (
      <div className="auth-card-header">
        <img
          src="/chewyandscout.jpg"
          alt="Chewy and Scout"
          className="auth-logo"
        />
        <h1>LilBytes</h1>
      </div>
    );
  },
};

function RainbowBar() {
  return (
    <div className="rainbow-bar">
      <div className="red"></div>
      <div className="orange"></div>
      <div className="yellow"></div>
      <div className="green"></div>
      <div className="blue"></div>
      <div className="indigo"></div>
      <div className="violet"></div>
    </div>
  );
}

function AppShell() {
  return (
    <Router>
      <UserProvider>
        <div className="App">
          <RainbowBar />
          <NavBar />
          <RoutesContainer />
        </div>
      </UserProvider>
    </Router>
  );
}

function AuthGate() {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  if (authStatus === "authenticated") {
    return <AppShell />;
  }

  return (
    <main className="auth-page">
      <RainbowBar />
      <section className="auth-intro" aria-label="Welcome">
        <p className="auth-kicker">Private family library</p>
        <h2>Welcome back to LilBytes.</h2>
        <p>
          If you're cool, sign in to add books or contribute to the art
          gallery, or you will be banned!
        </p>
      </section>
      <Authenticator components={authComponents} />
    </main>
  );
}

function App() {
  return (
    <Authenticator.Provider>
      <AuthGate />
    </Authenticator.Provider>
  );
}

export default App;
